import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const StartHero = () => {
  return (
    <React.Fragment>
      <>
        <section className="h2_nh_hero-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="h2_nh_hero-content pt-35">
                  <span className="h2_nh_hero-content-subtitle">
                    welcome to NexPe
                  </span>
                  <h1
                    className="h2_nh_hero-content-title"
                    style={{ fontSize: "60px" }}
                  >
                    Your One-Stop Recharge Solution!
                  </h1>
                  <p>
                    Simplify your digital payments with NexPe – the trusted
                    platform powered by FINGTEL COMMUNICATIONS for mobile, DTH,
                    and Google Play recharges. Experience fast, secure, and
                    hassle-free transactions anytime, anywhere.
                  </p>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.nexope.nexopeapp"
                    target="_blank"
                    className="nh_theme-btn"
                  >
                    Download App Now
                  </a>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="h2_nh_hero-img">
                  <img src="/images/recharge-banner-4.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    </React.Fragment>
  );
};

export default StartHero;
